import template from './signatureField.html';
import controller from './signatureField.controller';
import './signatureField.css';

import '../../../../vendor/jSignature/src/jSignature';
import '../../../../vendor/jSignature/src/plugins/jSignature.CompressorBase30';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    fieldResponse: '<',
    onUpdate: '&',
  }
};

export default component;

